module.exports = __webpack_public_path__ + "static/img/3003x.d7ca6cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3003x.png
// module id = pvXg
// module chunks = 1